import React, {PureComponent} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import './ReportsDialog.scss'
import Button from "@material-ui/core/Button";
import ShiftIcon from "../../../../Utils/Icons/SVGs/ShiftIcon";
import 'moment/locale/he';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/CloseRounded";
import MoneyReportDialog from "../MoneyReportDialog/MoneyReportDialog";
import ShiftsReportDialog from "../ShiftsReportDialog/ShiftsReportDialog";
import OrderIcon from "../../../../Utils/Icons/SVGs/OrderIcon";
import ReportsIcon from "@material-ui/icons/DescriptionRounded";

export default class ReportsDialog extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {};
    }

    handleClose() {
        if (this.props.onClose)
            this.props.onClose();
    }

    chooseReport(reportName) {
        this.setState({
            openedDialog: reportName
        });
    }

    closeReportDialog() {
        this.setState({
            openedDialog: undefined
        });
    }

    render() {
        return (
            <div>
                <Dialog
                    scroll={'paper'}
                    className="report-dialog"
                    open={this.props.open && !this.state.openedDialog}
                    onClose={this.handleClose.bind(this)}
                    aria-labelledby="form-dialog-title">
                        <DialogTitle id="form-dialog-title">
                            <div className="report-dialog-title-content">
                                <ReportsIcon style={{"fontSize": "32px"}}/>
                                &nbsp;
                                הפק דו״ח
                            </div>
                        </DialogTitle>
                        <DialogContent dividers={true}>
                            <div className="dialog-content">
                                <Button className="report-button"
                                        onClick={() => this.chooseReport("money")}>
                                    <div className="report-icon-wrapper">
                                        <OrderIcon/>
                                    </div>
                                    <div className="report-label">
                                        הזמנות
                                    </div>
                                </Button>
                                <Button className="report-button"
                                        onClick={() => this.chooseReport("shifts")}>
                                    <div className="report-icon-wrapper">
                                        <ShiftIcon/>
                                    </div>
                                    <div className="report-label">
                                        משמרות
                                    </div>
                                </Button>
                            </div>
                            <div className="dialog-actions">
                                <IconButton className="close-button"
                                            onClick={this.handleClose.bind(this)}>
                                    <CloseIcon fontSize="small"/>
                                </IconButton>
                            </div>
                        </DialogContent>
                </Dialog>

                <MoneyReportDialog match={this.props.match}
                                   open={this.state.openedDialog === "money"}
                                   onClose={() => this.closeReportDialog()}/>
                <ShiftsReportDialog match={this.props.match}
                                    open={this.state.openedDialog === "shifts"}
                                    onClose={() => this.closeReportDialog()}/>
            </div>
        );
    }
}